// ==============================
// Right Navigation Scroll Arrows + Overflow Indicators
// ==============================
const rightNavWrapper = document.querySelector(".theme-right-wrapper");
const rightNavInner = document.querySelector(".right-navigation");
const leftArrow = document.querySelector(".scroll-arrow.left");
const rightArrow = document.querySelector(".scroll-arrow.right");

if (rightNavWrapper && rightNavInner && leftArrow && rightArrow) {
  // Create left & right overflow indicators
  const leftIndicator = document.createElement("div");
  leftIndicator.className = "scroll-overflow-indicator left";
  leftIndicator.textContent = "...";
  rightNavWrapper.appendChild(leftIndicator);

  const rightIndicator = document.createElement("div");
  rightIndicator.className = "scroll-overflow-indicator right";
  rightIndicator.textContent = "...";
  rightNavWrapper.appendChild(rightIndicator);

  // Update arrows and overflow indicators
  function updateArrows() {
    const scrollLeft = rightNavInner.scrollLeft;
    const maxScroll = rightNavInner.scrollWidth - rightNavInner.clientWidth;
    const tolerance = 1; // small offset to account for fractional pixels

    // Disable/enable scroll arrows
    leftArrow.classList.toggle("disabled", scrollLeft <= 0);
    rightArrow.classList.toggle(
      "disabled",
      scrollLeft >= maxScroll - tolerance,
    );

    // Show/hide left indicator
    leftIndicator.style.opacity = scrollLeft > tolerance ? "1" : "0";

    // Show/hide right indicator
    rightIndicator.style.opacity =
      scrollLeft < maxScroll - tolerance ? "1" : "0";
  }

  // Scroll helpers
  leftArrow.addEventListener("click", () => {
    rightNavInner.scrollBy({ left: -150, behavior: "smooth" });
  });
  rightArrow.addEventListener("click", () => {
    rightNavInner.scrollBy({ left: 150, behavior: "smooth" });
  });

  // Update on scroll & resize
  rightNavInner.addEventListener("scroll", updateArrows);
  window.addEventListener("resize", updateArrows);

  // Initial check
  updateArrows();
}



// ==============================
// Start Theme Sidebar Show/Hide Functionality
// ==============================
document.addEventListener("DOMContentLoaded", () => {
  const container = document.querySelector(".theme-dropdown-container");

  if (!container) {
    return;
  }

  const children = container.querySelectorAll(
    ".theme-category-main-container > div",
  );

  // Show first child by default
  const firstParent = container.querySelector(
    ".theme-category-dropdown-parent",
  );
  if (firstParent && children.length) {
    firstParent.classList.add("active");
    children[0].classList.add("show");
  }

  // Event delegation for clicks on sidebar parents
  container.addEventListener("mouseover", (e) => {
    const li = e.target.closest(".theme-category-dropdown-parent");
    if (!li) return;

    e.preventDefault();

    const targetSelector = li.dataset.target;
    const targetChild = container.querySelector(targetSelector);
    if (!targetChild) return;

    // Remove 'active' and 'show' from all
    container
      .querySelectorAll(".theme-category-dropdown-parent")
      .forEach((p) => p.classList.remove("active"));
    container
      .querySelectorAll(".theme-category-main-container > div")
      .forEach((c) => c.classList.remove("show"));

    // Activate clicked parent and show child panel
    li.classList.add("active");
    targetChild.classList.add("show");
  });
});
// ==============================
// End Theme Sidebar Show/Hide Functionality
// ==============================

// ==============================
// Start of Offcanvas functionality
// ==============================
(function () {
  // Get the backdrop element
  const backdrop = document.getElementById("theme-backdrop");

  if (!backdrop) {
    return;
  }

  // Variable to keep track of the currently active offcanvas
  let activeOffcanvas = null;

  /**
   * Function to show an offcanvas element
   * @param {HTMLElement} el - The offcanvas element to show
   */
  function showOffcanvas(el) {
    if (!el) {
      return;
    }

    activeOffcanvas = el; // Set current offcanvas as active
    backdrop.classList.add("show"); // Show the backdrop
    el.classList.add("show"); // Show the offcanvas
    document.body.classList.add("theme-offcanvas-open"); // Prevent body scrolling

    // Determine if the offcanvas content needs vertical scroll
    const body = el.querySelector(".theme-offcanvas-body");
    if (body) {
      body.style.overflowY =
        body.scrollHeight > body.clientHeight ? "auto" : "hidden";
    }
  }

  /**
   * Function to hide the currently active offcanvas
   */
  function hideOffcanvas() {
    if (!activeOffcanvas) return; // If no offcanvas is active, do nothing
    backdrop.classList.remove("show"); // Hide the backdrop
    activeOffcanvas.classList.remove("show"); // Hide the offcanvas
    document.body.classList.remove("theme-offcanvas-open"); // Restore body scrolling
    activeOffcanvas = null; // Reset active offcanvas
  }

  // Attach click event to all elements that toggle offcanvas
  document
    .querySelectorAll('[data-bs-toggle="theme-offcanvas"]')
    .forEach((btn) => {
      btn.addEventListener("click", () => {
        const target = document.querySelector(
          btn.getAttribute("data-bs-target"),
        );
        showOffcanvas(target); // Show the targeted offcanvas
      });
    });

  // Clicking on backdrop hides the active offcanvas
  backdrop.addEventListener("click", hideOffcanvas);

  // Clicking on elements with [data-close] attribute hides the offcanvas
  document.addEventListener("click", (e) => {
    if (e.target.matches("[data-close]")) hideOffcanvas();
  });

  // Pressing Escape key hides the active offcanvas
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") hideOffcanvas();
  });
})();
// ==============================
// End of Offcanvas functionality
// ==============================

// ==============================
// Start: Attach click handler to all mobile menu toggles
// ==============================
document.querySelectorAll(".theme-mobile-toggle").forEach((toggle) => {
  toggle.addEventListener("click", function (e) {
    e.preventDefault();

    const submenu = this.nextElementSibling;
    const icon = this.querySelector("i");

    if (!submenu) return;

    const isOpen = submenu.style.maxHeight && submenu.style.maxHeight !== "0px";

    // Close sibling submenus (BS5-like)
    const parentList = this.closest("ul");
    if (parentList) {
      const siblings = parentList.querySelectorAll(":scope > li > ul");
      siblings.forEach((menu) => {
        if (menu !== submenu) {
          menu.style.maxHeight = "0";
          const parentIcon = menu.previousElementSibling?.querySelector("i");
          parentIcon?.classList.remove("theme-mobile-rotate");
        }
      });
    }

    // Toggle current submenu
    submenu.style.maxHeight = isOpen ? "0" : submenu.scrollHeight + "px";

    // Rotate icon safely
    if (icon) {
      icon.classList.toggle("theme-mobile-rotate", !isOpen);
    }
  });
});

// ==============================
// End: Attach click handler to all mobile menu toggles
// ==============================

// ==============================
// PRODUCT TAB SLIDER HOME
// ==============================
const rightNavWrapperProdTab = document.querySelector(
  ".thanks_givien_prod_tab_wrapper .theme-right-wrapper",
);
const rightNavInnerProdTab = document.querySelector(
  ".thanks_givien_prod_tab_wrapper .right-navigation",
);
const leftArrowProdTab = document.querySelector(
  ".thanks_givien_prod_tab_wrapper .scroll-arrow.left",
);
const rightArrowProdTab = document.querySelector(
  ".thanks_givien_prod_tab_wrapper .scroll-arrow.right",
);

if (
  rightNavWrapperProdTab &&
  rightNavInnerProdTab &&
  leftArrowProdTab &&
  rightArrowProdTab
) {
  // Create left & right overflow indicators
  const leftIndicatorProdTab = document.createElement("div");
  leftIndicatorProdTab.className = "scroll-overflow-indicator left";
  leftIndicatorProdTab.textContent = "...";

  const rightIndicatorProdTab = document.createElement("div");
  rightIndicatorProdTab.className = "scroll-overflow-indicator right";
  rightIndicatorProdTab.textContent = "...";

  rightNavWrapperProdTab.appendChild(leftIndicatorProdTab);

  rightNavWrapperProdTab.appendChild(rightIndicatorProdTab);

  // Update arrows and overflow indicators
  function updateArrowsProdTab() {
    const scrollLeft = rightNavInnerProdTab.scrollLeft;
    const maxScroll =
      rightNavInnerProdTab.scrollWidth - rightNavInnerProdTab.clientWidth;
    const tolerance = 1; // small offset to account for fractional pixels

    // Disable/enable scroll arrows
    leftArrowProdTab.classList.toggle("disabled", scrollLeft <= 0);
    rightArrowProdTab.classList.toggle(
      "disabled",
      scrollLeft >= maxScroll - tolerance,
    );
    // Show/hide left indicator
    leftIndicatorProdTab.style.opacity = scrollLeft > tolerance ? "1" : "0";

    // Show/hide right indicator
    rightIndicatorProdTab.style.opacity =
      scrollLeft < maxScroll - tolerance ? "1" : "0";
  }

  // Scroll helpers
  leftArrowProdTab.addEventListener("click", () => {
    rightNavInnerProdTab.scrollBy({ left: -150, behavior: "smooth" });
  });

  rightArrowProdTab.addEventListener("click", () => {
    rightNavInnerProdTab.scrollBy({ left: 150, behavior: "smooth" });
  });

  // Update on scroll & resize
  rightNavInnerProdTab.addEventListener("scroll", updateArrowsProdTab);
  window.addEventListener("resize", updateArrowsProdTab);

  // Initial check
  updateArrowsProdTab();
}

// ==============================
// PRODUCT TAB SLIDER HOME
// ==============================

document.addEventListener("DOMContentLoaded", function () {
  var tabs = document.querySelectorAll("#home_product_tabs a");
  var productContainer = document.getElementById("home_tab_products_content");
  var patentProductContainer = document.getElementById(
    "home_top_selling_products_wrap",
  );

  if (!tabs.length || !productContainer || !patentProductContainer) {
    initStarRating(document);
    return;
  }

  function initStarRating(context) {
    if (typeof jQuery === "undefined") return;
    if (typeof jQuery.fn.rate !== "function") return;

    var $ctx = jQuery(context);

    $ctx.find(".star-rating").each(function () {
      var $el = jQuery(this);

      // prevent double init
      if ($el.hasClass("rate-initialized")) return;

      $el.addClass("rate-initialized").rate({
        max_value: 5,
        step_size: 0.5,
        initial_value: 0,
        selected_symbol_type: "custom_utf8", // Give it a unique name
        symbols: {
          custom_utf8: {
            // Must match selected_symbol_type
            base: "☆", // Empty star
            hover: "★", // Hover star
            selected: "★", // Selected star
          },
        },
        cursor: "default",
        readonly: true,
      });
    });
  }

  function loadProducts(categoryId) {
    // fade out
    productContainer.classList.add("is-loading");

    // wait for fade-out to finish
    setTimeout(function () {
      fetch(
        "partials/home_tab_products-" +
          categoryId +
          ".html?category_id=" +
          encodeURIComponent(categoryId),
        {
          method: "GET",
          credentials: "same-origin",
        },
      )
        .then(function (response) {
          if (!response.ok) throw new Error();
          return response.text();
        })
        .then(function (html) {
          productContainer.innerHTML = html;

          // fade in
          productContainer.classList.remove("is-loading");
          patentProductContainer.classList.remove("no_product");

          // INIT STAR RATING FOR NEW CONTENT
          initStarRating(productContainer);
        })
        .catch(function () {
          productContainer.innerHTML =
            '<p class="no_products_error">No Products Found!!</p>';
          productContainer.classList.remove("is-loading");
          patentProductContainer.classList.add("no_product");
        });
    }, 300); // must match CSS transition duration
  } // load products end

  tabs.forEach(function (tab) {
    tab.addEventListener("click", function (e) {
      e.preventDefault();

      document.querySelectorAll("#home_product_tabs li").forEach(function (li) {
        li.classList.remove("active");
      });

      tab.parentElement.classList.add("active");

      loadProducts(tab.dataset.category);
    });
  });

  if (tabs.length) tabs[0].click();

  initStarRating(document);
}); // DOM Created

// ==============================
// MANUFACTURE FAMILY BRAND SHOW
// ==============================

document
  .querySelectorAll("#home_manufacturers_css_slider a.image[data-content]")
  .forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation(); // Prevent other handlers on same element

      const targetId = trigger.dataset.content;
      const target = document.getElementById(targetId);
      const container = document.querySelector(
        "#home_manufacturers_css_slider .family_brand_container",
      );

      if (!target || !container) return;

      //Hide all panels
      document
        .querySelectorAll(
          "#home_manufacturers_css_slider .family_brand_container",
        )
        .forEach((el) => {
          el.classList.add("v_hidden");
        });

      // Show outer container
      target.classList.remove("v_hidden");

      // Remove active from all triggers
      document
        .querySelectorAll("#home_manufacturers_css_slider .product")
        .forEach((el) => {
          el.classList.remove("active");
        });

      // add active current triggers
      // trigger.classList.add('active');
      trigger.parentElement.classList.add("active");

      // Toggle current panel
      const isHidden = target.classList.contains("v_hidden");
      if (isHidden) {
        target.classList.remove("v_hidden");
        // trigger.classList.add('active');
        trigger.parentElement.classList.add("active");
      } else {
        // target.classList.add('v_hidden');
        // trigger.classList.remove('active');
      }
    });
  });

// Close when clicking outside BOTH slider and panel
document.addEventListener("click", (e) => {
  const container = document.querySelector(
    "#home_manufacturers_css_slider .family_brand_container:not(.v_hidden)",
  );
  const slider = document.querySelector(
    "#home_manufacturers_css_slider .hp-feat-brands-css",
  );

  if (!container || !slider) return;

  const clickedInsidePanel = container.contains(e.target);
  const clickedInsideSlider = slider.contains(e.target);

  if (!clickedInsidePanel && !clickedInsideSlider) {
    container.classList.add("v_hidden");
    document
      .querySelectorAll(
        "#home_manufacturers_css_slider .family_brand_container",
      )
      .forEach((el) => {
        el.classList.add("v_hidden");
      });
    document
      .querySelectorAll("#home_manufacturers_css_slider .product")
      .forEach((el) => {
        el.classList.remove("active");
      });
  }
});
